import { Provider } from 'react-redux';

import { Meta, StoryObj } from '@storybook/react';

import { store } from '../../../../src/store';

import { GlobalNavigation } from './GlobalNavigation';

const meta: Meta<typeof GlobalNavigation> = {
  title: 'features/GlobalNavigation',
  component: GlobalNavigation,
};

export default meta;

type Story = StoryObj<typeof GlobalNavigation>;

export const Basic: Story = {
  render: () => (
    <Provider store={store}>
      <GlobalNavigation />
    </Provider>
  ),
};
